/**
 * Determines if a user is located in California, USA.
 * Handles both 2-letter ("US") and 3-letter ("USA") country codes,
 * and both "CA" and "US-CA" state code formats.
 * Case insensitive and trims whitespace.
 *
 * @param countryCode - The country code (US, USA, or other)
 * @param stateCode - The state code (CA, US-CA, or other)
 * @returns true if the location represents California, USA
 */
export const isUsaCalifornia = (
  countryCode?: string | null,
  stateCode?: string | null
): boolean => {
  if (!countryCode || !stateCode) {
    return false
  }

  const normalizedCountry = countryCode.trim().toUpperCase()
  const normalizedState = stateCode.trim().toUpperCase()

  const isUSCountry = normalizedCountry === 'US' || normalizedCountry === 'USA'
  const isCaliforniaState =
    normalizedState === 'CA' || normalizedState === 'US-CA'

  return isUSCountry && isCaliforniaState
}

const GOOGLE_BLOCKED_COUNTRY_CODES = [
  'BH', // Bahrain
  'BA', // Bosnia and Herzegovina
  'EG', // Egypt
  'KR', // South Korea
  'KW', // Kuwait
  'OM', // Oman
  'PH', // Philippines
  'QA', // Qatar
  'SA', // Saudi Arabia
  'SG', // Singapore
  'ZA', // South Africa
  'TH', // Thailand
  'TR', // Turkiye
  'AE', // United Arab Emirates
  'VN', // Vietnam
]

export const isGoogleBlockedRegion = (
  countryCode?: string | null,
  stateCode?: string | null
): boolean => {
  if (isUsaCalifornia(countryCode, stateCode)) {
    return true
  }

  if (!countryCode) {
    return false
  }

  const normalized = countryCode.trim().toUpperCase()
  return GOOGLE_BLOCKED_COUNTRY_CODES.includes(normalized)
}

export const isIndia = (countryCode?: string | null): boolean => {
  if (!countryCode) {
    return false
  }

  const normalizedCountry = countryCode.trim().toUpperCase()

  const isIndia = normalizedCountry === 'IN' || normalizedCountry === 'IND'

  return isIndia
}
